import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { useTestId } from '../../hooks';
import { forwardRefWithName } from '../../utils';
const lightClassNames = {
    display1: 'txt-light-display1',
    display2: 'txt-light-display2',
    heading1: 'txt-light-heading1',
    heading2: 'txt-light-heading2',
    heading2Plus: 'txt-light-heading2plus',
    heading3: 'txt-light-heading3',
    heading4: 'txt-light-heading4',
    heading5: 'txt-light-heading5',
    heading5Plus: 'txt-light-heading5plus',
    heading6: 'txt-light-heading6',
    navItem: 'txt-light-navitem',
    numberTag: 'txt-light-numbertag',
    display3: 'txt-light-display3',
    bodyXL: 'txt-light-bodyxl',
    bodyLarge: 'txt-light-bodylarge',
    body: 'txt-light-body',
    bodySmallPlus: 'txt-light-bodysmallplus',
    bodySmall: 'txt-light-bodysmall',
    bodySmallUnderlined: 'txt-light-bodysmall-underlined',
    bodyXSPlus: 'txt-light-bodyxsplus',
    bodyXS: 'txt-light-bodyxs',
    bodyXSMedium: 'txt-light-bodyxsmedium',
    captionTitle: 'txt-light-captiontitle',
    caption: 'txt-light-caption',
    captionTitleSmall: 'txt-light-captiontitlesmall',
    captionSmall: 'txt-light-captionsmall',
    badge: 'txt-light-badge',
};
const mobileClassNames = {
    display1: 'txt-mobile-display1',
    display2: 'txt-mobile-display2',
    heading1: 'txt-mobile-heading1',
    heading2: 'txt-mobile-heading2',
    heading2Plus: 'txt-mobile-heading2plus',
    heading3: 'txt-mobile-heading3',
    heading4: 'txt-mobile-heading4',
    heading5: 'txt-mobile-heading5',
    display3: 'txt-mobile-display3',
};
function TextComponent(props, ref) {
    const { children, mode = 'light', variant = 'body', className, testId = 'text' } = props, spanProps = __rest(props, ["children", "mode", "variant", "className", "testId"]);
    const tid = useTestId(testId, spanProps);
    const classList = twMerge(mode === 'light'
        ? lightClassNames[variant]
        : mobileClassNames[variant], className);
    return (_jsx("span", Object.assign({ ref: ref, className: classList }, spanProps, tid(), { children: children })));
}
export const Text = forwardRefWithName(TextComponent);
//# sourceMappingURL=Text.js.map